import IMask from 'imask'

export default {
  mounted(el: HTMLInputElement) {
    IMask(el, {
      mask: '000 000-00-00'
    })
  },
}